import React, { useState, useEffect, Fragment } from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { Row, Col, Table, Spinner } from "react-bootstrap";
import Edit from "./Edit";
import ErrorModal from "../../ErrorModal";
import DeleteConfirmation from "../../shared/DeleteConfirmation";
import MyJustDate from "../../shared/MyJustDate";

const baseURL = process.env.REACT_APP_API_JOBS;

const Listdelete = ({
  increment,
  counter,
  setCounter,
  moamad_id,
  moamad,
  hagsha_aharon,
}) => {
  const [recommends, setRecommends] = useState(null);
  const [recId, setRecId] = useState(null);

  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorHeader, setErrorHeader] = useState("");
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const hagshaDate = MyJustDate(new Date(Date.parse(hagsha_aharon)));
  const currentDate = MyJustDate(Date.now());

  const readOnly =
    moamad.signature_date ||
    (hagshaDate && currentDate && hagshaDate < currentDate);

  const handleEditClick = (event, rec) => {
    event.preventDefault();
    setRecId(rec.id);
  };
  const handleCancelClick = () => {
    setRecId(null);
  };
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "recommend?moamad_id=" + moamad_id,
          {
            signal: controller.signal,
          }
        );
        isMounted && setRecommends(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getData();
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [counter]);

  if (!recommends) return null;
  if (loading) {
    // Render a spinner while the data is loading
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <div>
          <Row>
            <Col sm="10" md={{ size: 3, offset: 1 }}>
              <form onSubmit={increment}>
                <Table hover>
                  <thead>
                    <tr>
                      <th>שם פרטי</th>
                      <th>שם משפחה</th>
                      <th>תפקיד</th>
                      <th>כתובת</th>
                      <th>טלפון</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recommends?.map((rec) => (
                      <Fragment key={rec.id}>
                        {recId === rec.id ? (
                          <Edit
                            rec={rec}
                            handleCancelClick={handleCancelClick}
                            increment={increment}
                            counter={counter}
                            setRecId={setRecId}
                          />
                        ) : (
                          <ReadOnlyRows
                            rec={rec}
                            handleEditClick={handleEditClick}
                            increment={increment}
                            setRecId={setRecId}
                            setShowError={setShowError}
                            setErrorMessage={setErrorMessage}
                            setErrorHeader={setErrorHeader}
                            readOnly={readOnly}
                          />
                        )}
                      </Fragment>
                    ))}
                  </tbody>
                </Table>
              </form>
            </Col>
          </Row>
        </div>
        <ErrorModal
          showError={showError}
          setShowError={setShowError}
          errorMessage={errorMessage}
          errorHeader={errorHeader}
        />
      </>
    );
  }
};
export default Listdelete;

const ReadOnlyRows = ({
  rec,
  handleEditClick,
  setRecId,
  increment,
  setShowError,
  setErrorMessage,
  setErrorHeader,
  readOnly,
}) => {
  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const [deleteObj, setDeleteObj] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [deleteMessage, setDeleteMessage] = useState(null);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const showDeleteModal = (type, id, event) => {
    setType(type);
    setId(id);
    setDeleteObj(event);
    setDeleteMessage(`מחיקת השכלה "${rec.title}": האם אתה בטוח? `);
    setDisplayConfirmationModal(true);
  };

  // Hide the modal
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const delData = async () => {
      try {
        const response = await axiosPrivate.delete(
          baseURL + "recommend/" + rec.id,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          increment();
          setRecId(null);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    delData();
  };

  return (
    <>
      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={handleDelete}
        hideModal={hideConfirmationModal}
        type={type}
        id={rec.id}
        event={deleteObj}
        message={deleteMessage}
      />
      <tr>
        <td>{rec.first_name}</td>
        <td>{rec.last_name}</td>
        <td>{rec.job}</td>
        <td>{rec.address}</td>
        <td>{rec.tel}</td>
        <td style={{ textAlign: "left", direction: "rtl" }}>
          <div className="d-flex justify-content-end">
            <button
              disabled={readOnly}
              type="button"
              className="btn btn-success"
              onClick={(event) => handleEditClick(event, rec)}
            >
              <FiEdit2 />
            </button>
            <span> </span>

            <button
              disabled={readOnly}
              type="button"
              className="btn btn-danger space-button"
              onClick={(event) => showDeleteModal("recommends", rec.id, event)}
            >
              <FiTrash2 />
            </button>
          </div>
        </td>
      </tr>
    </>
  );
};
